import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Nav = (props) => (
  <nav className="navbar navbar-default">
    <div className="container-fluid">
      <div className="navbar-header">
        <Link className="navbar-brand" to="/">
          <img alt="Brand" src={props.brandImage} height="30px" />
        </Link>
      </div>
    </div>
  </nav>
);


Nav.propTypes = {
  brandImage: PropTypes.string,
};

export default Nav;
